/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('BoardPayment', BoardPayment);

    BoardPayment.$inject = ['$resource', 'DateUtils'];

    function BoardPayment ($resource, DateUtils) {
        var resourceUrl =  'api/board/payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    if (data.project) {
                        data.project.fromDate = DateUtils.convertLocalDateFromServer(data.project.fromDate);
                        data.project.untilDate = DateUtils.convertLocalDateFromServer(data.project.untilDate);
                    }
                    if (data.dinghyEvent) {
                        data.dinghyEvent.fromDate = DateUtils.convertDateTimeFromServer(data.dinghyEvent.fromDate);
                        data.dinghyEvent.untilDate = DateUtils.convertDateTimeFromServer(data.dinghyEvent.untilDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    if (copy.project) {
                        copy.project.fromDate = DateUtils.convertLocalDateToServer(copy.project.fromDate);
                        copy.project.untilDate = DateUtils.convertLocalDateToServer(copy.project.untilDate);
                    }
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    if (copy.project) {
                        copy.project.fromDate = DateUtils.convertLocalDateToServer(copy.project.fromDate);
                        copy.project.untilDate = DateUtils.convertLocalDateToServer(copy.project.untilDate);
                    }
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
